// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__3oO15","title":"ClientCherryInfo_title__1RB5Q","itemText":"ClientCherryInfo_itemText__1OIr5"};